var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "booking-header-close",
      attrs: { "data-component": "booking-header-close" },
    },
    [
      _vm.back
        ? _c("button", {
            staticClass: "icon-arrow-back",
            attrs: { "aria-label": _vm.tc("booking.back"), tabindex: "0" },
            on: {
              click: _vm.back,
              keypress: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.back($event)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.back($event)
                },
              ],
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "booking-header-close-title" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.deactivate
        ? _c("button", {
            staticClass: "icon-close",
            attrs: { "aria-label": _vm.tc("booking.close"), tabindex: "0" },
            on: {
              click: _vm.deactivate,
              keypress: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.deactivate($event)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.deactivate($event)
                },
              ],
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }